import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import TextField from 'apollo-react/components/TextField';
import Tooltip from 'apollo-react/components/Tooltip';
import ChevronDown from 'apollo-react-icons/ChevronDown';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import Trash from 'apollo-react-icons/Trash';
import React, { useEffect, useState } from 'react';

import { decodeString, getUITA } from '../../../../../utils/commonUtils';
import { DATALOOKUP_TYPE_EXTERNAL_API } from '../../../../constants/form-manager.constants';

export const NameCell = ({ row, column: { accessor: key } }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(row[key]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[key]]);

  const onChangeHandler = ({ target: { value } }) => {
    setValue(value);
    row.editRow(row.id, key, value);
  };

  switch (row?.dataLookUpType) {
    case DATALOOKUP_TYPE_EXTERNAL_API:
      return (
        <div style={{ width: 'auto' }}>
          <Select
            size="small"
            fullWidth
            value={value}
            onChange={onChangeHandler}
            canDeselect={false}
          >
            {row.fieldList.map(({ value, label }) => {
              return (
                <MenuItem key={`${row.id} + ${value}`} value={value}>
                  {label ? `${label} (${value})` : value}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      );

    default:
      return (
        <TextField
          size="small"
          fullWidth
          value={value}
          onChange={({ target }) => setValue(target.value)}
          onBlur={onChangeHandler}
        />
      );
  }
};

export const ValueCell = ({ row, column: { accessor: key } }) => {
  const [codeIcon, setCodeIcon] = useState(true);
  const [value, setValue] = useState(row[key]);

  useEffect(() => {
    setValue(row[key]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[key]]);

  return (
    <Tooltip
      extraLabels={[{ title: '' }, { subtitle: row[key] }]}
      placement="bottom"
      variant="light"
    >
      <TextField
        size="small"
        fullWidth
        value={decodeString(value) ?? ''}
        icon={
          codeIcon ? <ChevronRight fontSize="extraSmall" /> : <ChevronDown fontSize="extraSmall" />
        }
        iconProps={{
          onClick: () => {
            row.handleToggleRow(row.id, key);
            setCodeIcon(!codeIcon);
          },
          'ui-ta': getUITA('ExpandableComponent', codeIcon ? 'open' : 'close', 'button'),
          size: 'small',
        }}
        onChange={({ target }) => {
          setValue(target.value);
        }}
        onBlur={() => {
          row.editRow(row.id, key, value);
        }}
        inputProps={{
          style: { borderColor: codeIcon ? '' : 'blue' },
        }}
        disabled={row.expanded ? codeIcon : false}
        ui-ta={getUITA('Query Params Value', 'Select')}
      />
    </Tooltip>
  );
};

export const ActionCell = ({ row }) => {
  const { id, deleteRow } = row;
  return (
    <div style={{ paddingTop: 10 }}>
      <IconButton onClick={() => deleteRow(id)}>
        <Trash />
      </IconButton>
    </div>
  );
};
